fx.ns("repositories", class ThemeTagRepository extends fx.ModelArray {

    constructor()
    {
        super([]);
    }

    getThemeTagFromStr(str)
    {
        let themetag;
        
        if (str.toLowerCase().includes(fx.text("mariage")) ||
            str.toLowerCase().includes(fx.text("wedding")))
            themetag = this.find({folder:"wedding"});
        else
        if (str.toLowerCase().includes(fx.text("naissance")) ||
            str.toLowerCase().includes(fx.text("bébé")))
            themetag = this.find({folder:"baby"});
        else
        if (str.toLowerCase().includes(fx.text("voyage")) || 
            str.toLowerCase().includes(fx.text("vacance")) ||
            str.toLowerCase().includes(fx.text("trip")) 
        )
            themetag = this.find({folder:"travel"});
        else
        if (str.toLowerCase().includes(fx.text("anniversaire")))
            themetag = this.find({folder:"birthday"});
        else
        if (str.toLowerCase().includes(fx.text("famille")))
            themetag = this.find({folder:"family"});
        else
            themetag = this.find({folder:"classic"});
        
        return themetag;
    }
   
});
